var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H13.25V8C13.25 8.9665 14.0335 9.75 15 9.75H20.9992C20.9997 9.76904 21 9.78811 21 9.80721V20C21 21.1046 20.1046 22 19 22H11.1536C12.5873 20.8077 13.5 19.0104 13.5 17C13.5 13.4101 10.5899 10.5 7 10.5C5.49147 10.5 4.10297 11.0139 3 11.8762V4C3 2.89543 3.89543 2 5 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 2.61172L20.2768 8.24999H15C14.8619 8.24999 14.75 8.13806 14.75 7.99999V2.52417C14.7808 2.55232 14.8108 2.58151 14.8399 2.61172Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22C9.76142 22 12 19.7614 12 17C12 14.2386 9.76142 12 7 12C4.23858 12 2 14.2386 2 17C2 19.7614 4.23858 22 7 22ZM7.75 14V16.25H10C10.4142 16.25 10.75 16.5858 10.75 17C10.75 17.4142 10.4142 17.75 10 17.75H7.75V20C7.75 20.4142 7.41421 20.75 7 20.75C6.58579 20.75 6.25 20.4142 6.25 20V17.75H4C3.58579 17.75 3.25 17.4142 3.25 17C3.25 16.5858 3.58579 16.25 4 16.25H6.25V14C6.25 13.5858 6.58579 13.25 7 13.25C7.41421 13.25 7.75 13.5858 7.75 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFiles);
export default __webpack_public_path__ + "static/media/add-files.b546fb96b0bbe603c06461adb8e5919a.svg";
export { ForwardRef as ReactComponent };